import { Directive } from '@angular/core';
import { ImmomioIconName } from '../../models';
import { Store } from '@ngrx/store';
import * as fromMasterDataState from '../../+state/account/masterdata';
import { InitResetPassword } from '../../+state';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Directive()
export class UserChangePasswordPageBaseComponent {
  public userEmail: string;
  protected readonly immomioIconName = ImmomioIconName;

  constructor(private store: Store) {
    store
      .select(fromMasterDataState.getUser)
      .pipe(takeUntilDestroyed())
      .subscribe(s => (this.userEmail = s.email));
  }

  sendEmail(isWeb?: boolean) {
    if (isWeb) {
      this.store.dispatch(InitResetPassword({ email: this.userEmail, web: true }));
    } else {
      this.store.dispatch(InitResetPassword({ email: this.userEmail }));
    }
  }
}
